<template>
    <div :class="['page about',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false;" />
        <div class="page-content copper">
            <div style="position: relative;">
                <img class="page-image" src="/CopperThanks-2.png" />
                <div class="div-btns" style="position: absolute;top:0px;left:0px">
                    <p @click="signUp" style="background-color: rgba(200,0,0,0);width:320px;height:80px;top:283px;left: 30px;position: absolute;"></p>
                </div>
            </div>
        </div>  
    </div>
   
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    name: 'copper-welcome',
    mixins: [ pageOn ],
    components: {
        VHeader
    },
    mounted () {
        var width = parseInt(getComputedStyle(this.$el.querySelector('.page-content')).width);
        this.$el.querySelector('.div-btns').style.transform = 'scale('+( width / 414 )+')';
    },
    methods: {
        signUp () {
            window.location = 'https://www.copperhousebar.co.uk/';
        },
        terms () {

        }
    },
    ...mapMutations([
      'popPage',
      'pushPage',
      'setValue'
    ])
    
}

</script>

<style>

</style>